export default __webpack_public_path__ + "static/media/icon-third-farm.6d791ca8.svg";